import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=04c47809"
import script from "./NoContent.vue?vue&type=script&lang=ts"
export * from "./NoContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports